module.exports = __webpack_public_path__ + "static/media/game-scene.06b2aacc.glb";